export enum UserOnboardingFlow {
    A = "objectiveFirst",
    B = "prospectsFirst",
    C = "directApp",
}
export enum TaskNameUserOnboarding {
    LINK_TO_LINKEDIN = "link_to_linkedin",
    COMPLETE_LISTS = "complete_lists",
    CONTACT_PROFILES = "contact_profiles",
    SYNC_WITH_LINKEDIN = "sync_with_linkedin",
}
export enum ONBOARDING_GOALS {
    CONTACT_PROSPECTS = "contactProspects",
    EXPAND_NETWORK = "growNetwork",
    FIND_EMAILS = "findProEmails",
}
